import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const charterAdapter = createEntityAdapter({
    selectId: (payment) => payment.guid,
});

const initialState = charterAdapter.getInitialState();

const charterSlice = createSlice({
    name: 'charter',
    initialState,
    reducers: {
        addStages: charterAdapter.addMany,
        updateOne: charterAdapter.updateOne,
        updateMany: charterAdapter.updateMany,
    },
});

export const charterSelector = charterAdapter.getSelectors((state) => state.charterReducer);
export const { actions: charterActions } = charterSlice;
export const { reducer: charterReducer } = charterSlice;
